import { API } from "aws-amplify";
import { getUserDetailsQuery } from "../../../../../Queries/RolesAndPermissionsQuery/RolesAndPermissionQuery";

export const getCurrentUser = (ID) => {
  return API.graphql({
    query: getUserDetailsQuery,
  });
};
